import { useNavigate } from 'react-router-dom';

//Internal Components
import './LogoBis.css';

const LogoBis: React.FC<any> =()=>{
    const navigate = useNavigate();

    return(
        <div className={'menu_background'} onClick={() => {navigate(`/bisformulario`)} }>
            <div className={`menu_logoCollapsed1`}></div>
        </div>
         
    )
}

export default LogoBis;